module.exports = __webpack_public_path__ + "img/wechat-pay.6613ae3e.svg";